/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScheduleRecommendationFiltersResponse {
    getFixupPrototypeFunction() { return ScheduleRecommendationFiltersResponse.fixupPrototype; }

    static newInstance(model: Partial<ScheduleRecommendationFiltersResponse>): ScheduleRecommendationFiltersResponse {
        let obj = Object.assign(new ScheduleRecommendationFiltersResponse(), model);
        ScheduleRecommendationFiltersResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScheduleRecommendationFiltersResponse>): ScheduleRecommendationFiltersResponse {
        if (!model) return null;
        return ScheduleRecommendationFiltersResponse.newInstance(<ScheduleRecommendationFiltersResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScheduleRecommendationFiltersResponse) {
        if (!obj) return;

        models.ScheduleRecommendationFiltersResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScheduleRecommendationFiltersResponse): boolean {
        Object.setPrototypeOf(obj, ScheduleRecommendationFiltersResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Currencies
     */
    currencies: Array<models.Currency>;

    /**
     * Service Names
     */
    services: Array<models.CloudServiceName>;

    /**
     * Tenant Ids
     */
    tenant_ids: Array<string>;

    /**
     * Service Account Ids
     */
    service_account_ids: Array<string>;

}
